import styled from 'styled-components';
import { Paper, ToggleGroup as SharedToggleGroup, theme, minBp } from '@triumph/shared';
import { Button } from '@triumph/shared';
import _CalculatorIcon from 'src/assets/icons/calculator.svg';
import RichText from 'components/_utility/RichText/RichText';

export const Wrap = styled(Paper)`
  padding: 30px 20px;
  margin-bottom: 24px;

  @media ${minBp('desktop')} {
    padding: 43px 62px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 11px;
  font-size: 20px;
  line-height: 24px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 22px;
    line-height: 30px;
    margin: 0 0 8px;
  }
`;

export const Description = styled.div`
  font-size: 14px;
  padding-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.hairline};
  margin-bottom: 18px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    padding-bottom: 42px;
    margin-bottom: 33px;
  }
`;

export const ToggleLabel = styled.h4`
  margin: 0 0 8px;
  font-size: 16px;
  line-height: 20px;
  font-family: ${theme.fonts.dinDemi};

  @media ${minBp('tablet')} {
    margin: 0 0 14px;
  }
`;

export const Breakdown = styled.div`
  padding: 30px;
  background: #f6f6f6;
  margin: 17px 0 24px;

  @media ${minBp('tablet')} {
    margin: 0;
    margin-left: 20px;
    min-width: 60%;
    max-width: 60%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  @media ${minBp('desktop')} {
    margin-left: 90px;
    min-width: 465px;
    max-width: 465px;
  }
`;

export const BreakdownTitle = styled.h4`
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 20px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;

  @media ${minBp('tablet')} {
    margin: 0 0 40px;
  }
`;

export const BreakdownDescription = styled.div`
  ${({ $highlight, theme }) =>
    $highlight
      ? `
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: ${theme.colors.heading};
      `
      : `
        font-size: 14px;
      `}

  line-height: 22px;
  margin: 0 0 17px;

  &:last-child {
    margin: 0;
  }

  & > p:last-child {
    margin: 0;
  }

  p {
    line-height: 22px; // Override legacy Triumph CSS
  }

  @media ${minBp('tablet')} {
    margin: 0 0 30px;

    &:last-child {
      margin: 0;
    }
  }
`;

export const BreakdownImageWrap = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;

  &:not(:last-child) {
    margin-bottom: 30px;
  }
`;

export const BreakdownImage = styled.img`
  width: 100%;
  height: auto;
  margin: 0 auto;
  vertical-align: middle;
  object-fit: contain;
`;

export const BreakdownImageLabels = styled.div`
  margin-top: 33px;
  display: flex;
  align-items: center;
  justify-content: ${({ count }) => count === 1 ? 'center' : 'space-between'};
`;

export const BreakdownImageLabel = styled.div`
  max-width: 25%;
  text-align: center;
  font-size: 10px;

  @media ${minBp('tablet')} {
    font-size: 11px;
  }
`;

export const Summary = styled(RichText)`
  font-size: 13px;
  line-height: 22px;
  margin: 0 0 17px;

  @media ${minBp('tablet')} {
    margin: 0 0 34px;
    font-size: 14px;
  }
`;

export const ChoiceOuter = styled.div`
  @media ${minBp('tablet')} {
    display: flex;
    margin: 0 0 30px;
  }
`;

export const ToggleGroup = styled(SharedToggleGroup)`
  @media ${minBp('tablet')} {
    flex: 1;
  }
`;

export const CalculatorButton = styled(Button)`
  padding-right: 16px;
  padding-left: 16px;
`;

export const CalculatorIcon = styled(_CalculatorIcon)`
  margin-right: 14px;
  overflow: visible;
  width: 14px;
`;
